var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_3853",
  "data-name": "Group 3853",
  transform: "translate(-448 769)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_22",
  "data-name": "Ellipse 22",
  cx: 8,
  cy: 8,
  r: 8,
  transform: "translate(448 -769)",
  fill: "#f8c62d"
}), /*#__PURE__*/React.createElement("g", {
  id: "shoppingcart",
  transform: "translate(451 -765)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "M6.966,8.907A1.105,1.105,0,0,1,5.894,7.774a1.179,1.179,0,0,1,.215-.681H4.425a1.192,1.192,0,0,1,.215.681A1.1,1.1,0,0,1,3.568,8.907,1.105,1.105,0,0,1,2.5,7.774a1.179,1.179,0,0,1,.215-.681H2.055a.366.366,0,0,1-.33-.214.4.4,0,0,1,.032-.406l.782-1.348L1.932,2.018,1.685.78H.369A.38.38,0,0,1,0,.39.38.38,0,0,1,.369,0H1.984a.376.376,0,0,1,.362.309L2.4.59,9.007.613a.358.358,0,0,1,.278.138.4.4,0,0,1,.079.313L8.644,5.316a.369.369,0,0,1-.358.316l-5.192.01-.313.672H9.006a.39.39,0,0,1,0,.778H7.823a1.187,1.187,0,0,1,.216.681A1.105,1.105,0,0,1,6.966,8.907Zm0-1.482a.349.349,0,1,0,.33.349A.34.34,0,0,0,6.966,7.425Zm-3.4,0a.349.349,0,1,0,.33.349A.34.34,0,0,0,3.568,7.425ZM2.555,1.358h0l.7,3.517,4.727-.008.59-3.487L2.555,1.358Z",
  transform: "translate(0 0)",
  fill: "#fff"
})))));
export default __webpack_public_path__ + "static/media/inTransitShipments.39681067.svg";
export { SvgComponent as ReactComponent };